<template>
  <v-card class="pa-5">
    <div class="d-flex">
      <div class="text-right" style="flex: 0 0 auto">
        <v-icon color="success" style="font-size:54px">
          mdi-check-circle
        </v-icon>
      </div>
      <v-divider vertical class="mx-6"/>
      <div style="flex: 1 1 auto">
        <div class="c-caption success--text" style="font-size:1.3rem">
          {{ $t('page.manageFiling.successSplash.title') }}
        </div>
        <div class="font-weight-light" style="font-size: 1.35rem;max-width:80ch">
          {{ $t('page.manageFiling.successSplash.description') }}
        </div>
        <div class="mt-10">
          <c-btn large type="primary" style="min-width:160px" @click="statusHistoryPopupVisible = true;">
            {{ $t('page.manageFiling.sidebar.statusHistory') }}
          </c-btn>
          <c-btn v-if="hasReceipt" large type="primary" style="min-width:160px" @click="viewReceipt">
            {{ $t('global.viewReceipt') }}
          </c-btn>
          <c-btn large style="min-width:160px" @click="$emit('returnToSummary')">
            {{ $t('page.manageFiling.sidebar.returnToSummary') }}
          </c-btn>
        </div>
      </div>
    </div>

    <filing-status-history-popup v-model="statusHistoryPopupVisible"/>
  </v-card>
</template>

<script>
import _ from 'lodash';
import FilingStatusHistoryPopup from '@components/support/manageFiling/FilingStatusHistoryPopup';
import { useFilingStore } from '@/stores/filingStore';

const filingStore = useFilingStore();

export default {
  components: { FilingStatusHistoryPopup },
  data () {
    return {
      statusHistoryPopupVisible: false
    };
  },
  computed: {
    hasReceipt () {
      return !_.isNil(filingStore.filing.receipt);
    }
  },
  methods: {
    viewReceipt () {
      this.$router.push({ name: 'receipt', params: { receiptID: filingStore.filing.receipt.resourceID } });
    }
  }
};
</script>